import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, []);

  const goPrev = () =>
    setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  const goNext = () => setCurrent((prev) => (prev + 1) % heroSlides.length);

  const active = heroSlides[current];

  return (
    <section className="relative h-[440px] w-full overflow-hidden md:h-[600px]">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.backdrop}
            alt={`${slide.title} 焦点海报`}
            title={`${slide.title} - 97视频`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-background-50/40"></div>
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1400px] flex-col justify-center px-4 md:px-8">
        <div key={active.id} className="animate-fade-up max-w-xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-medium text-accent-400">
            <i className="ri-fire-fill" aria-hidden="true"></i>
            {active.label}
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            {active.title}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {active.subtitle}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${active.id}`}
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-play-fill text-lg" aria-hidden="true"></i>
              立即观看
            </Link>
            <Link
              to={`/detail/${active.id}`}
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-700/40 bg-background-50/40 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-50/70"
            >
              <i className="ri-information-line text-lg" aria-hidden="true"></i>
              影片详情
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={goPrev}
        aria-label="上一张"
        className="absolute left-3 top-1/2 z-20 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-black/40 text-white transition-colors hover:bg-black/60 md:left-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-left-s-line text-2xl" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        onClick={goNext}
        aria-label="下一张"
        className="absolute right-3 top-1/2 z-20 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-black/40 text-white transition-colors hover:bg-black/60 md:right-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-right-s-line text-2xl" aria-hidden="true"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第${index + 1}张`}
            onClick={() => setCurrent(index)}
            className={`h-1.5 cursor-pointer rounded-full transition-all ${
              index === current
                ? "w-7 bg-accent-500"
                : "w-3 bg-foreground-800/40 hover:bg-foreground-800/70"
            }`}
          />
        ))}
      </div>
    </section>
  );
}